// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260644/js/" + chunkId + "." + {"44":"8e986d6c","225":"7eba5367","481":"329df42a","486":"e3d6efb2","770":"c436e598"}[chunkId] + ".0.9717151880146494.chunk.js";
};